import reducer, { InferenceResultSubdivState } from "./reducers";
import * as inferenceResultSubdivOperations from "./operations";
export {
  inferenceResultSubdivOperations,
  InferenceResultSubdivState
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/inferenceSubdiv/index.ts